<template>
  <div class="studioSet-basicInfo">
    <el-form :model="basicInfoForm"
             :rules="rules"
             ref="basicInfoFormRef"
             label-width="120px"
             class="demo-ruleForm">
      <el-form-item label="标题"
                    prop="list_title">
        <el-input v-model="basicInfoForm.list_title"
                  clearable
                  size="small"></el-input>
      </el-form-item>
      <el-form-item label="图文详情"
                    prop="list_info_url"
                    class="list_info_url-box">
        <UploadImg :f_thumb="basicInfoForm.list_info_url"
                   :f_thumb_str="basicInfoForm.list_info_url_str"
                   @emitImg="emitImg"></UploadImg>
        <div class="prompt">建议尺寸750*640px，支持jpg、png、jpeg格式,15M以内</div>
      </el-form-item>

      <el-form-item label="APP链接地址">
        <div style="text-align: left;"> {{link.app}}</div>
      </el-form-item>
      <el-form-item label="小程序链接地址">
        <div style="text-align: left;"> {{link.applet}}</div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary"
                   :disabled="module_id_array[0] ? !module_id_array.includes('1576') : false"
                   @click="submitForm('basicInfoFormRef')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import department from '@/api/department.js';
import BasicInfo from './BasicInfo.vue';
import ListMaintain from './ListMaintain.vue';
import UploadImg from '@/components/uploadImg/index';
export default {
  components: {
    BasicInfo,
    ListMaintain,
    UploadImg
  },
  data() {
    return {
      basicInfoForm: {
        list_id: '',
        list_title: '',
        list_info_url: '',
        list_info_url_str: ''
      },
      rules: {
        list_title: [{ required: true, message: '请输入', trigger: 'blur' }],
        list_info_url: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ]
      },
      link: {
        app: '',
        applet: ''
      }
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:ss');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case '1':
          return BasicInfo;
        case '2':
          return ListMaintain;
      }
    }
  },
  created() {
    this.getFamousDoctorList();
  },
  methods: {
    getFamousDoctorList() {
      department.getFamousDoctorList().then((res) => {
        let { code, data } = res;
        if (code === 0) {
          if (!data.list.length) {
            this.basicInfoForm = {
              list_id: '',
              list_title: '',
              list_info_url: '',
              list_info_url_str: ''
            };
          } else {
            this.basicInfoForm = data.list[0];
          }

          this.link = data.link;
          this.$router.push({
            path: '/home/department/studioSet',
            query: {
              list_id: this.basicInfoForm.list_id
            }
          });
        }
      });
    },
    emitImg(data) {
      let { path, pic } = data;
      this.basicInfoForm.list_info_url = pic;
      this.basicInfoForm.list_info_url_str = path;
      this.$refs['basicInfoFormRef'].validateField(['list_info_url']);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let params = _.omit(this.basicInfoForm, ['list_info_url_str']);
          department
            .saveFamousDoctorList(params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success('保存成功');
                this.getFamousDoctorList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped >
.studioSet-basicInfo {
  .demo-ruleForm {
    width: 600px;
    .list_info_url-box {
      ::v-deep.el-form-item__content {
        height: 150px;
      }
    }
  }
}
</style>